function SvgKulaTextLogo(props) {
  return (
    <svg
      width={407}
      height={128}
      viewBox="0 0 407 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M229.13 108.56L203 73.46l22.23-23.92c1.17-1.17.65-2.34-1.04-2.34h-17.68c-.91 0-1.56.26-2.21 1.04l-20.8 22.62V17.95c0-1.17-.78-1.95-1.95-1.95h-15.6c-1.17 0-1.95.78-1.95 1.95v91c0 1.17.78 1.95 1.95 1.95h15.6c1.17 0 1.95-.78 1.95-1.95V94.52l7.67-8.32 17.68 23.53c.65.91 1.3 1.17 2.34 1.17h16.77c1.56 0 1.95-1.04 1.17-2.34zM297.049 47.2h-15.6c-1.17 0-1.95.78-1.95 1.95v33.93c0 4.81-3.77 11.31-12.09 11.31-4.94 0-11.18-2.86-11.18-13.13V49.15c0-1.17-.78-1.95-1.95-1.95h-15.6c-1.17 0-1.95.78-1.95 1.95v36.01c0 17.03 10.14 27.43 24.31 27.43 7.67 0 14.17-4.42 18.46-10.53l.52 6.89c.13 1.17.78 1.95 1.95 1.95h15.08c1.17 0 1.95-.78 1.95-1.95v-59.8c0-1.17-.78-1.95-1.95-1.95zM310.377 17.95v91c0 1.17.78 1.95 1.95 1.95h15.6c1.17 0 1.95-.78 1.95-1.95v-91c0-1.17-.78-1.95-1.95-1.95h-15.6c-1.17 0-1.95.78-1.95 1.95zM404.794 47.2h-14.17c-1.17 0-1.82.78-1.95 1.95l-.39 5.33c-4.55-5.2-10.66-8.71-18.2-8.71-17.68 0-30.68 14.82-30.68 33.41 0 18.59 13 33.41 30.68 33.41 7.8 0 13.78-3.38 18.2-8.32l.39 4.68c.13 1.17.78 1.95 1.95 1.95h14.17c1.17 0 1.95-.78 1.95-1.95v-59.8c0-1.17-.78-1.95-1.95-1.95zm-32.24 47.58c-8.32 0-14.43-6.76-14.43-15.73 0-8.84 6.11-15.6 14.43-15.6 8.19 0 14.3 7.15 14.3 15.6s-6.11 15.73-14.3 15.73z"
        fill={props.textColor ?? 'var(--kula-dark-secondary-950, #131415)'}
      />
      <rect
        x={1.939}
        y={1.939}
        width={124.121}
        height={124.121}
        rx={46.545}
        fill="url(#kula-text-logo_svg__paint0_linear)"
      />
      <rect
        x={2.909}
        y={2.909}
        width={122.182}
        height={122.182}
        rx={45.576}
        stroke="#FDF3F3"
        strokeOpacity={0.06}
        strokeWidth={1.939}
      />
      <g filter="url(#kula-text-logo_svg__filter0_d)">
        <rect
          x={31.831}
          y={32.401}
          width={23.078}
          height={63.464}
          rx={11.539}
          fill="url(#kula-text-logo_svg__paint1_linear)"
        />
      </g>
      <path
        d="M96.035 91.377V72.072a5.054 5.054 0 00-5.054-5.054H70.116c-2.977 0-5.345 2.583-4.66 5.479 3.844 16.238 17.08 22.586 26.225 23.343 2.5.207 4.354-1.953 4.354-4.462z"
        fill="url(#kula-text-logo_svg__paint2_linear)"
      />
      <circle
        cx={82.66}
        cy={45.727}
        r={13.327}
        fill="url(#kula-text-logo_svg__paint3_linear)"
      />
      <rect
        x={2.51}
        y={2.51}
        width={122.98}
        height={122.98}
        rx={47.268}
        stroke="url(#kula-text-logo_svg__paint4_linear)"
        strokeWidth={5.02}
      />
      <defs>
        <linearGradient
          id="kula-text-logo_svg__paint0_linear"
          x1={64}
          y1={1.939}
          x2={64}
          y2={126.06}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#222527" />
          <stop offset={1} stopColor="#131415" />
        </linearGradient>
        <linearGradient
          id="kula-text-logo_svg__paint1_linear"
          x1={38.735}
          y1={42.632}
          x2={50.863}
          y2={86.26}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EAECEB" />
          <stop offset={1} stopColor="#D9E9EE" />
        </linearGradient>
        <linearGradient
          id="kula-text-logo_svg__paint2_linear"
          x1={80.302}
          y1={67.017}
          x2={80.302}
          y2={95.918}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CFF5F3" />
          <stop offset={1} stopColor="#BBF2EF" />
        </linearGradient>
        <linearGradient
          id="kula-text-logo_svg__paint3_linear"
          x1={82.66}
          y1={32.4}
          x2={82.66}
          y2={59.055}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF8F76" />
          <stop offset={1} stopColor="#EB4A27" />
        </linearGradient>
        <linearGradient
          id="kula-text-logo_svg__paint4_linear"
          x1={64}
          y1={0}
          x2={64}
          y2={128}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCFCF6" />
          <stop offset={1} stopColor="#8FA1DF" />
        </linearGradient>
        <filter
          id="kula-text-logo_svg__filter0_d"
          x={31.03}
          y={31.921}
          width={24.679}
          height={65.065}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={0.32} />
          <feGaussianBlur stdDeviation={0.4} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
      </defs>
    </svg>
  );
}

export default SvgKulaTextLogo;
